export default "__VITE_ASSET__BNgFSqKS__"